import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import DatePickerInput from "./DatePickerInput"; // Import our custom input

const isValidDate = (date) => {
    return date instanceof Date && !isNaN(date);
};

const CustomDatePicker = ({ selected, onChange, label, name, minDate }) => {
    // Ensure selected is a valid Date object
    let selectedDate = null;
    if (selected) {
        const d = selected instanceof Date ? selected : new Date(selected);
        if (isValidDate(d)) selectedDate = d;
    }

    return (
        <DatePicker
            selected={selectedDate}
            onChange={(date) => onChange({ target: { name, value: moment(date).format("YYYY-MM-DDTHH:mm:ss") } })}
            onSelect={(date) => onChange({ target: { name, value: moment(date).format("YYYY-MM-DDTHH:mm:ss") } })}
            onCalendarClose={() => onChange({ target: { name, value: moment(selectedDate || new Date()).format("YYYY-MM-DDTHH:mm:ss") } })}
            onCalendarOpen={() => {/* noop to keep focus */}}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            dateFormat="yyyy-MM-dd HH:mm"
            minDate={minDate}
            customInput={<DatePickerInput label={label} />}
        />
    );
};

export default CustomDatePicker;
